import React from 'react'
import './ModButton.css'
import ModBorder from '../ModBorder/ModBorder'

/**
 * Компонент кнопки с градиентной обводкой и hover эффектами
 * @param {Object} props
 * @param {string} [props.label] - Текст кнопки (альтернатива children)
 * @param {'primary'|'danger'|'secondary'} [props.severity='primary'] - Тип кнопки
 * @param {Function} [props.onClick] - Callback при клике
 * @param {boolean} [props.disabled] - Отключена ли кнопка
 * @param {React.ReactNode} [props.children] - Дочерние элементы (альтернатива label)
 * @param {string} [props.className] - Дополнительные CSS классы
 * @param {boolean} [props.hasBorder=true] - Показывать ли границу кнопки
 */
export default function ModButton({
  label,
  severity = 'primary',
  size,
  onClick,
  disabled,
  children,
  className,
  hasBorder = true,
  ...props
}) {
  const getSeverityClass = () => {
    switch (severity) {
      case 'primary':
        return 'mod-button-wrapper--primary'
      case 'danger':
        return 'mod-button-wrapper--danger'
      case 'secondary':
      default:
        return 'mod-button-wrapper--secondary'
    }
  }

  const getButtonContentClass = () => {
    switch (severity) {
      case 'primary':
        return 'mod-button--primary'
      case 'danger':
        return 'mod-button--danger'
      case 'secondary':
      default:
        return 'mod-button--secondary'
    }
  }

  const getInnerContentBgColor = () => {
    switch (severity) {
      case 'primary':
        return 'var(--m-button-def)'
      case 'danger':
      case 'secondary':
      default:
        return 'var(--m-bg-placeholder)'
    }
  }

  const getBorderColorTl = () => {
    switch (severity) {
      case 'primary':
        return 'var(--m-color-stroke-primary)'
      case 'danger':
        return 'var(--m-color-wrong)'
      case 'secondary':
      default:
        return 'var(--m-color-stroke-primary)'
    }
  }

  const getBorderColorBr = () => {
    switch (severity) {
      case 'primary':
        return 'var(--m-color-stroke-secondary)'
      case 'danger':
        return 'var(--m-color-wrong)'
      case 'secondary':
      default:
        return 'var(--m-color-stroke-secondary)'
    }
  }

  const severityClass = getSeverityClass()
  const sizeClass = size === 'sm' ? 'mod-button-wrapper--sm' : ''
  const buttonContentClass = getButtonContentClass()
  const buttonWrapperClassName = `mod-button-wrapper ${severityClass} ${sizeClass} ${className || ''}`.trim()
  const buttonClassName = `mod-button ${buttonContentClass}`

  const innerBgColor = getInnerContentBgColor()
  const borderColorTl = hasBorder ? getBorderColorTl() : innerBgColor
  const borderColorBr = hasBorder ? getBorderColorBr() : innerBgColor

  const buttonStyle = {
    '--mod-border-color-tl': borderColorTl,
    '--mod-border-color-br': borderColorBr,
    '--mod-inner-bg': innerBgColor,
  }

  return (
    <button className={buttonWrapperClassName} onClick={onClick} disabled={disabled} style={buttonStyle} {...props}>
      <ModBorder
        className='mod-button-border'
        radius='var(--m-radius-md)'
        innerContentBgColor={getInnerContentBgColor()}
      >
        <span className={buttonClassName}>{children || label}</span>
      </ModBorder>
    </button>
  )
}
